import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import ExamCountdown from "../../components/ExamCountdown";

export default function CaseStudyPracticeTake() {
  const navigate = useNavigate();

  const [practice, setPractice] = useState(null);
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);

  /* ================= MATH FORMAT FUNCTION ================= */
  function formatMath(text) {
  if (!text) return "";

  const map = {
    "0":"⁰","1":"¹","2":"²","3":"³","4":"⁴",
    "5":"⁵","6":"⁶","7":"⁷","8":"⁸","9":"⁹","-":"⁻"
  };

  return text.replace(/\^(-?\d+)/g, (_, p) =>
    p.split("").map(c => map[c] || c).join("")
  );
}
  /* ===============================
     LOAD DATA FROM SESSION
  =============================== */
  useEffect(() => {
    const data = sessionStorage.getItem("caseStudyPractice");

    if (!data) {
      alert("Session expired");
      navigate("/student/study");
      return;
    }

    const parsed = JSON.parse(data);

    setPractice(parsed);

    // 🔥 TIMER SET
    if (parsed.duration_minutes) {
      setTimeLeft(parsed.duration_minutes * 60);
    }

  }, [navigate]);

  useEffect(() => {
  if (!timeLeft) return;

  const timer = setInterval(() => {
    setTimeLeft((prev) => {
      if (prev <= 1) {
        clearInterval(timer);
        handleTimerExpire();
        return 0;
      }
      return prev - 1;
    });
  }, 1000);

  return () => clearInterval(timer);
}, [timeLeft]);

  /* ===============================
     SELECT ANSWER
  =============================== */
  const chooseAnswer = (questionId, option) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionId]: option,
    }));
  };

  /* ===============================
     SUBMIT PRACTICE
  =============================== */
  const submitPractice = async () => {
    if (!practice) return;

    setSubmitting(true);

    try {
      const res = await api.post(
        "/student/case-study-practice/submit",
        {
          practice_set_id: practice.practice_set_id,
          answers: selectedAnswers,
        }
      );

      // Save result like practice set
      sessionStorage.setItem(
        "caseStudyResult",
        JSON.stringify(res.data)
      );

      sessionStorage.removeItem("caseStudyPractice");

      navigate("/student/case-study/result", {
        state: { attemptId: res.data.attempt_id }
      });
    } catch (err) {
      alert("❌ Submission failed");
    } finally {
      setSubmitting(false);
    }
  };
  const handleTimerExpire = () => {
    alert("⏰ Time up! Submitting automatically.");
    submitPractice();
  };

  if (!practice) {
    return <p style={{ padding: 30 }}>⏳ Loading...</p>;
  }

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>

        {/* LOGO */}
        <div style={{ textAlign: "center", marginBottom: 20 }}>
          <img
            src="/logo.png"
            alt="EduAt10"
            style={{ width: 120 }}
          />
        </div>

        {/* MAIN CONTENT */}
        <div style={boxStyle}>
          <h2 style={{ marginBottom: 20 }}>
            📘 {formatMath(practice.title)}
          </h2>

          <div style={timerBox}>
            ⏱ Time Left: {Math.floor(timeLeft / 60)}:
            {String(timeLeft % 60).padStart(2, "0")}
          </div>

          {practice.case_studies.map((cs, index) => (
            <div key={cs.id} style={csBox}>
              <h3>
                {index + 1}. {formatMath(cs.title)}
              </h3>

              <p style={paraStyle}>
                {formatMath(cs.description)}
              </p>

              {cs.questions.map((q, i) => (
                <div key={q.id} style={qBox}>
                  <b>
                    Q{i + 1}. {formatMath(q.text)}
                  </b>

                  {["a", "b", "c", "d"].map((opt) => {
                    const key = `option_${opt}`;
                    return (
                      <label key={opt} style={optStyle}>
                        <input
                          type="radio"
                          name={`q_${q.id}`}
                          checked={selectedAnswers[q.id] === opt}
                          onChange={() => chooseAnswer(q.id, opt)}
                        />
                        {" "}{formatMath(q[key])}
                      </label>
                    );
                  })}
                </div>
              ))}
            </div>
          ))}

          {/* SUBMIT BUTTON */}
          <button
            onClick={submitPractice}
            disabled={submitting}
            style={submitBtn}
          >
            {submitting ? "Submitting..." : "Submit Case Study"}
          </button>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: 30,
};

const boxStyle = {
  background: "#ffffff",
  borderRadius: 16,
  padding: 30,
  maxWidth: 900,
  margin: "0 auto",
  boxShadow: "0 8px 20px rgba(0,0,0,0.15)",
};

const csBox = {
  marginBottom: 40,
};

const paraStyle = {
  whiteSpace: "pre-wrap",
  background: "#f8fafc",
  padding: 15,
  borderRadius: 8,
  marginTop: 10,
};

const qBox = {
  marginTop: 15,
};

const optStyle = {
  display: "block",
  marginLeft: 20,
  marginTop: 6,
  cursor: "pointer",
};

const submitBtn = {
  marginTop: 30,
  padding: "14px 30px",
  background: "#2563eb",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 16,
  cursor: "pointer",
};

const timerBox = {
  background: "#fff3cd",
  padding: 10,
  borderRadius: 8,
  marginBottom: 20,
  fontWeight: 600,
};
